import { render, staticRenderFns } from "./ProofreadTopBarIcon.vue?vue&type=template&id=1c350104&"
import script from "./ProofreadTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./ProofreadTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports